import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';


import FormSelect from '../../../global/Form/FormElement/FormSelect';


function LanguageSelectForm(props) {

    const {formatMessage} = useIntl();

    const {languages} = props;
    const languageOptions = languages.map(({tag}) => ({
            label: formatMessage({id: `language.${tag}`}),
            value: tag
        }))
        .sort((language1, language2) => {

            const label1 = language1.label;
            const label2 = language2.label;

            return label1.localeCompare(label2);
        });

    return (
        <FormSelect
            {...props}
            options={languageOptions}
        />
    );
}


LanguageSelectForm.propTypes = {
    ...FormSelect.propTypes,
    languages: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            tag: PropTypes.string.isRequired
        })
    ).isRequired,
    value: PropTypes.string
};


LanguageSelectForm.defaultProps = {
    ...FormSelect.defaultProps
};


export default LanguageSelectForm;
